interface Config {
  apiUrl: string;
}

const config: Config = {
  apiUrl: process.env.REACT_APP_API_URL || 'https://ai-api.ehost.tj',
};

export default config; 